import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({item,handleCalculate,setIsOpenAddProduct,setEditDetails}) => {


  

  return (
 
      // <div className="product-card">
      //   <h3 className="product-title">{item?.productId ?? ""}</h3>
      //   <button 
      //     className={`calculate-btn`}
      //     onClick={()=>handleCalculate(item?.productId ?? "")}
        
      //   >
      //     Calculate
      //   </button>
      // </div>

      //  <div class="app-container">
    <>
    <div class="product-card">
         
            <div class="card-header">

                <h3 class="product-title">{item?.productId ?? ""}</h3>
              
             <div className="header-left">
                <div class="product-desc">{item?.productDesc ?? ""}</div>
                  <button className='edit-btn' style={{marginLeft:"1rem"}} onClick={()=>{setIsOpenAddProduct(true);setEditDetails(item) }}>
                   <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </button>  
             </div>   
            </div>
            
            <div class="details-grid">
                 <div class="detail-item">
                    <div class="detail-label">Processing Fee</div>
                    <div class="detail-value">{(item?.processingFee ?? "").toString()}</div>
                </div>
                
                 <div class="detail-item">
                    <div class="detail-label">Interest Rate</div>
                    <div class="detail-value">{(item?.interestRate ?? "").toString()}</div>
                </div>
                
                {/* <div class="detail-item">
                    <div class="detail-label">Number of EMIs</div>
                    <div class="detail-value">3</div>
                </div> */}
                
                <div class="detail-item">
                    <div class="detail-label">Deployment Ratio</div>
                    <div class="detail-value">{(item?.deploymentRatio ?? "0").toString()}%</div>
                </div>
                
                <div class="detail-item">
                    <div class="detail-label">Deployment Number</div>
                    <div class="detail-value">{(item?.deploymentNum ?? "").toString()}</div>
                </div>
                
                <div class="detail-item">
                    <div class="detail-label">Product Weightage</div>
                    <div class="detail-value">{(item?.productWeightage ?? "").toString()}%</div>
                </div>
                
                <div class="detail-item">
                    <div class="detail-label">APR</div>
                    <div class="detail-value">{(item?.apr ?? "").toString()}%</div>
                </div>
                
                <div class="detail-item">
                    <div class="detail-label">Risk Factor</div>
                    <div class="detail-value">{(item?.riskFactor ?? "").toString()}%</div>
                </div>
                
                <div class="detail-item">
                    <div class="detail-label">Average Ticket Size</div>
                    <div class="detail-value currency">{(item?.averageTicketSize ?? "").toString()}</div>
                </div>
                
                <div class="detail-item">
                    <div class="detail-label">Conversion Ratio</div>
                    <div class="detail-value">{(item?.conversionRatio ?? "").toString()}%</div>
                </div>
                
                <div class="detail-item">
                    <div class="detail-label">Penalty Charge</div>
                    <div class="detail-value">{(item?.penaltyCharge ?? "").toString()}%</div>
                </div>
            </div>
        
            <button 
                class="calculate-btn"
                onClick={()=>handleCalculate(item?.productId ?? "")}
                >
                Calculate
            </button>
          
              
        {/* </div> */}
    </div>
    
    </>
  );
};

export default ProductCard;